<template>
  <div>
    <div>
      <el-table
        ref="table"
        :data="list"
        :key="list.length"
        :height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Promotions" prop="deviceId" min-width="224">
          <template v-slot="{ row }">
            <div>{{ promotionMap[row.id] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="User Promotions Setting" prop="promotionStatus" min-width="179">
          <template v-slot="{ row }">
            <!-- <el-switch
              v-model="row.promotionStatus"
              @change="handleStatusChange(row)"
            /> -->
            <el-select :disabled="!row.editable" v-model="row.promotionStatus" @change="handleStatusChange(row,$event)">
              <el-option label="Default" :value="null"></el-option>
              <el-option label="Enable" :value="true"></el-option>
              <el-option label="Disable" :value="false"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="User Promotions Effective Status" prop="finalPromotionStatus" min-width="220">
            <template #header>
              <div>
                <span>User Promotions Effective Status</span>
                <el-tooltip content="User’s effective eligibility is activated only when the conditions of the user settings, channel settings, and risk control configuration are all satisfied." placement="top">
                  <i class="el-icon-warning-outline" style="margin-left: 4px; color: #fff; cursor: pointer;"></i>
                </el-tooltip>
              </div>
            </template>
            <template v-slot="{ row }">
              <span v-if="row.finalPromotionStatus == null">Default</span>
              <span v-if="row.finalPromotionStatus == true">Enable</span>
              <span v-if="row.finalPromotionStatus == false">Disable</span>
            </template>
          </el-table-column>
        <el-table-column label="Last Update Time" min-width="222">
          <template v-slot="{ row }">
            <div>{{ formatUtc(row.updateTime) }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Operator" prop="users" min-width="223">
          <template v-slot="{ row }">
            <div>{{ row.updateUser }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Empty from "@/components/empty/index";
import { updatePromotionStatus } from "@/api/channel";

export default {
  name: "RiskDetail",
  components: {
    Empty,
  },
  props: {
    handleCheckHistoryStatus: {
      type: Boolean
    },
    handleCheckUserInfoStatus: {
      type: Boolean
    },
    promotionConfigs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: [],
      itemList: [],
      total: 0,
      fastData: "",
      freeDate: "",
      rowIp: "",
      nowDate: Date.now(),
      form: {},
      firstActive: false,
      loading: false,
      loadingItem: false,
      queryData: {
        userId: "",
        current: 1,
        size: 50
      },
      totalAert: 0,
      queryAlert: {
        current: 1,
        size: 50
      },
      tableHeight: window.innerHeight,
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        }
      },
      promotionMap: {
        1001: 'Soccer Early Payout',
        3001: 'Basketball Early Payout',
      },

    };
  },
  watch: {
    handleCheckHistoryStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 150;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 150;
        });
      }
    },
    promotionConfigs: {
      handler(val) {
        this.list = val.map(item => ({
          ...item
        }))
        this.total = this.list.length
      },
      immediate: true
    },
    handleCheckUserInfoStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 115;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 115;
        });
      }
    }
  },
  methods: {
    async getList() {
      this.queryData.userId = this.$route.query.userId;
      this.loading = true;
      try {
        //this.list = this.promotionConfigs
        // this.list = this.promotionConfigs.map(item => ({
        //   ...item
        // }));
        this.total = this.list.length;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    // 查看详情
    handleViewDetail(data) {
      if (data.userId) {
        this.Close();
        this.$router.push({
          path: "/member/detail",
          query: { userId: data.userId }
        });
      }
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    },
    handleChange(data) {
      this.title = "Device ID Related Member";
      this.rowIp = data;
    },
    Close() {

    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // 分页
    changeAlertPage(e) {
      this.queryAlert.current = e;
    },
    // 列表显示条目
    handleSizeAlertChange(e) {
      this.queryAlert.size = e;
      this.queryAlert.current = 1;
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    formatDate(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD");
    },
    formatOddsLevel(val) {
      if (val == 1) {
        return "A";
      } else if (val == 2) {
        return "B";
      } else if (val == 3) {
        return "C";
      } else if (val == 4) {
        return "D";
      } else if (val == 5) {
        return "E";
      }
    },
    async handleStatusChange(row, newVal) {
      const prevVal = row._prevPromotionStatus ?? row.promotionStatus

      // 先记录旧值（用于失败回滚）
      row._prevPromotionStatus = prevVal

      try {
        const res = await updatePromotionStatus({
          userId: this.queryData.userId,
          promotionId: row.id,
          status: newVal
        })

        if (res.code == 0) {
          this.$message({ message: "update success", type: "success", duration: 3000 })
          // 成功：把 prev 更新为当前值
          row._prevPromotionStatus = newVal
          // 如果你还想更新时间/操作人（后端没返回就先不动）
          // row.updateTime = Date.now()
          // row.updateUser = this.$store?.state?.user?.name || row.updateUser
        } else {
          row.promotionStatus = prevVal
          this.$message({ message: res.message, type: "warning", duration: 3000 })
        }
      } catch (error) {
        row.promotionStatus = prevVal
        this.$message({ message: error?.message || "update failed", type: "warning", duration: 3000 })
      }
    }

  },
  mounted() {
    this.firstActive = true;
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.el-dialog .el-table thead th {
  color: #fff !important;
  background: #2f4162 !important;
}
.bettinfo-date {
  font-size: 12px;
  margin: 0 0 15px 0;
}
.ip-name {
  color: #0184b8;
  font-weight: 700;
}
.re-ip-name {
  color: #e1554f;
}
.use-types {
  span {
    &:last-child {
      i {
        display: none;
      }
    }
  }
}
.users {
  color: #0184b8;
  cursor: pointer;
}
</style>
<style lang="scss">
.el-dialog .el-table thead th {
  color: #fff !important;
  background: #2f4162 !important;
}
</style>
